var findDOMNode = require('react-dom').findDOMNode;
var React = require("react");

var DragSource = require('react-dnd').DragSource;
var DropTarget = require('react-dnd').DropTarget;

var Types = {
  ROW: 'row'
};

var rowSource = {
    isDragging(props, monitor) {
        return monitor.getItem().id === props.id
    },

    beginDrag: function (props) {
        return { id: props.id };
    }
};

var rowTarget = {
    hover: function (props, monitor, component) {
        var draggedId = monitor.getItem().id;
        var hoverId = props.id
        if (draggedId === hoverId) {
            return;
        }

        const hoverBoundingRect = (findDOMNode(
            component,
        )).getBoundingClientRect();
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        const clientOffset = monitor.getClientOffset();
        const hoverClientY = (clientOffset).y - hoverBoundingRect.top;
        if (draggedId < hoverId && hoverClientY < hoverMiddleY) {
            return;
        }
        if (draggedId > hoverId && hoverClientY > hoverMiddleY) {
            return;
        }

        var hoverField = props.targetField
        if (draggedId.search(hoverField)===-1) {
            return;
        }

        if (draggedId !== props.id) {
            props.moveRow(draggedId, props.id);
        }
    }
};

var sourceCollect = function(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var targetCollect = function(connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
};

var component = React.createClass({
    render: function() {
        let {item,can_drag,getRowClassName,id} = this.props
        var opacity = this.props.isDragging ? 0 : 1;
        var connectDragSource= this.props.connectDragSource;
        var connectDropTarget = this.props.connectDropTarget;
        
        if (can_drag) {
            return connectDragSource(connectDropTarget(
                <tr style={{opacity: opacity}} className={getRowClassName!==undefined?getRowClassName(item,id):''}>
                    {this.props.renderColDetail(item)}
                </tr>
            ));
        } else {
            return(
                <tr style={{opacity: opacity}} className={getRowClassName!==undefined?getRowClassName(item,id):''}>
                    {this.props.renderColDetail(item)}
                </tr>
            )
        } 
    }
});

var source = DragSource(Types.ROW, rowSource, sourceCollect)(component);
var row = DropTarget(Types.ROW, rowTarget, targetCollect)(source);

module.exports = row;


// WEBPACK FOOTER //
// ./src/view/workdoc/fast/DNDRowItem.js